export default __webpack_public_path__ + "static/media/Path 2543.00badbc5.png";